/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeTestJobRequest, type ErrorResponse, type InternalErrorResponse, type TestJobRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs/test
 */
export interface TestRequestBuilder extends BaseRequestBuilder<TestRequestBuilder> {
    /**
     * Diagnostic for the background job queue: enqueues one product-change command built from the supplied identifiers and returns as soon as it is queued, without waiting for it to run. Nothing is written to the product itself. Anonymous - it takes no credentials and is scoped only by the identifiers in the body.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: TestJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * Diagnostic for the background job queue: enqueues one product-change command built from the supplied identifiers and returns as soon as it is queued, without waiting for it to run. Nothing is written to the product itself. Anonymous - it takes no credentials and is scoped only by the identifiers in the body.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: TestJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TestRequestBuilderUriTemplate = "{+baseurl}/api/jobs/test";
/**
 * Metadata for all the requests in the request builder.
 */
export const TestRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: TestRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeTestJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
